import { render, staticRenderFns } from "./clazz-chart.vue?vue&type=template&id=5e644b84&scoped=true&"
import script from "./clazz-chart.vue?vue&type=script&lang=js&"
export * from "./clazz-chart.vue?vue&type=script&lang=js&"
import style0 from "./clazz-chart.vue?vue&type=style&index=0&id=5e644b84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e644b84",
  null
  
)

export default component.exports